var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGoBack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 10,
    r: 9.5,
    fill: "#ECEEEC",
    stroke: "#5C715E"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.8066 6.47332C11.5466 6.21332 11.1266 6.21332 10.8666 6.47332L7.80657 9.53332C7.54657 9.79332 7.54657 10.2133 7.80657 10.4733L10.8666 13.5333C11.1266 13.7933 11.5466 13.7933 11.8066 13.5333C12.0666 13.2733 12.0666 12.8533 11.8066 12.5933L9.21991 9.99999L11.8066 7.41332C12.0666 7.15332 12.0599 6.72665 11.8066 6.47332Z",
    fill: "#5C715E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoBack);
export default __webpack_public_path__ + "static/media/goBack.6ada8077d2eaefe6334d8cdfddd513e8.svg";
export { ForwardRef as ReactComponent };